import { render, staticRenderFns } from "./LoginScreen.vue?vue&type=template&id=246de1f5&"
import script from "./LoginScreen.vue?vue&type=script&lang=ts&"
export * from "./LoginScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports